import React, { useState, useMemo, useContext } from "react"
import {
  Box,
  Card,
  Button,
  CardContent,
  CircularProgress,
  useTheme,
} from "@material-ui/core"
import PropTypes from "prop-types"
import {
  toggleSendBillingDialog,
  toggleClickConfirmationDialog,
} from "../../../../actions/billingDialogs"
import { useDispatch } from "react-redux"
import GreenButton from "../../Common/GreenButton/index"
import useStyles from "./styles"
import EstimateStatusCard from "../EstimateStatusCard"
import { useSelector } from "react-redux"
import {
  updateDealMemoBillingStep,
  updateGeneralDataProperties,
  updateDealMemoClientStatus,
} from "../../../../actions/billing"
import { openSnackBar } from "../../../../actions/snack-bar"
import NextStep from "../../../NextStep/index"
import moment from "moment"
import BillingContext from "../../../../pages/Shoot/pages/Billing/BillingContext"
import calculateTotals from "../../../../utils/calculateTotals"
import EstimateDeposit from "../EstimateDeposit/index"
import { isEmpty } from "lodash"
import LoadingButton from "../../../LoadingButton/index"
import usePaidAmountEstimate from "../../../../hooks/usePaidAmountEstimate"
import { createClientInvoice } from "../../../../actions/payments"

const EstimateRightContent = props => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const theme = useTheme()

  let shootId = props.match.params.shoot_id

  const generalData = useSelector(state => state.billing.generalData)
  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)

  const [switchLoading, setSwitchLoading] = useState(false)
  const [sendLoading, setSendLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  const billingContext = useContext(BillingContext)
  const depositRequired = generalData && Boolean(generalData.deposit_required)
  const discount = (generalData && generalData.discount) || 0
  const allSaved = billingContext.unsavedState.length === 0

  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )

  const paidAmt = usePaidAmountEstimate()

  const estimateSent = useMemo(
    () => {
      if (generalData) {
        return Boolean(generalData.estimate_sent)
      }
    },
    [generalData]
  )

  const estimateAccepted = useMemo(
    () => {
      if (generalData) {
        return Boolean(generalData.estimate_accepted)
      }
    },
    [generalData]
  )

  const invoiceSent = generalData && Boolean(generalData.invoice_sent)

  const amounts = useMemo(
    () => {
      // copy of usersrolesarray where we exclude not billable expenses
      let newUsersRolesArray = usersRolesArray.map(role => {
        let newRole = { ...role }
        return newRole
      })
      return calculateTotals(newUsersRolesArray, paidAmt, discount)
    },
    [usersRolesArray, discount, paidAmt]
  )

  const handleDepositRequired = () => {
    // console.log('amounts', amounts);
    // console.log('generalData', generalData);
    setSwitchLoading(true)
    // dispatch(createClientInvoice({
    //   first_paid: depositRequired ? 1 : 0,
    //   first_half_amount: amounts.half,
    // }))
    //   .then(res => {
    //     console.log('response', res)
    //   })
    dispatch(
      updateGeneralDataProperties(
        {
          deposit_required: Number(!depositRequired),
          // first_paid: !depositRequired ? 1 : 0,
          // first_half_amount: amounts.half,
        },
        shootId
      )
    )
      .then(() => {
        setSwitchLoading(false)
      })
      .catch(err => {
        console.log(err)
        setSwitchLoading(false)
      })
  }

  const startDate = moment(generalData.start_date).format("MMM Do YYYY")
  const daysAway = moment(generalData.start_date)
    .startOf("day")
    .fromNow()

  const nextStepMessage = useMemo(() => {
    let message = " "
    if (generalData.billing_step_name === "Deal Memo") {
      message =
        "Once all crew members have accepted their deal memos, the shoot will be booked."
    } else if (generalData.billing_step_name === "Estimate") {
      message =
        "Once the shoot has wrapped, each crew member will submit any additional shoot expenses for you to review."
    } else if (generalData.billing_step_name === "Bill Approval") {
      message =
        "Once the client has accepted your additional expenses and paid in full, your shoot payment will be transferred."
    } else if (generalData.billing_step_name === "Invoice") {
      message =
        "Once the client accepts and pay this invoice in a timely manner so that we may submit payment to the shoot crew."
    } else {
      message = "Not a valid shoot"
    }
    return message
  })

  // *** SEND ESTIMATE   ***
  const handleSendEstimate = dialogVals => {
    setSendLoading(true)
    const requestData = {
      action_type: "estimate",
      email_to: dialogVals.recipients.join(", "),
      subject: dialogVals.subject,
      message: dialogVals.message,
    }
    dispatch(updateDealMemoClientStatus(requestData, shootId, "sent"))
      .then(() => {
        dispatch(openSnackBar({ message: "Sent Estimate to Client" }))
        setSendLoading(false)
      })
      .catch(err => {
        console.log(err)
        setSendLoading(false)
        dispatch(openSnackBar({ message: "Error sending estimate to client" }))
      })
  }

  const openSendDialog = () => {
    let defaultEmail =
      generalData.estimate_sent_to || generalData.client_email
        ? (generalData.estimate_sent_to || generalData.client_email)
            .split(",")
            .map(x => x.trim())
        : null
    let dialogData = {
      type: "Estimate",
      shootName: generalData.name,
      defaultEmail: defaultEmail,
      sendFunc: handleSendEstimate,
    }
    dispatch(toggleSendBillingDialog(true, dialogData))
  }

  const confirmSendDialog = e => {
    //using button text as key to type - resend or send
    let type = e.target.innerText.split(" ")[0].toLowerCase()

    !allSaved && billingContext.setUnsavedErrorBorder(true)
    let defaultEmail =
      generalData.estimate_sent_to || generalData.client_email
        ? (generalData.estimate_sent_to || generalData.client_email)
            .split(",")
            .map(x => x.trim())
        : null

    let data = {
      // `${type} estimate to client`
      action: !allSaved && `${type} estimate to client without saving`,
      type: "Estimate",
      shootName: generalData.name,
      defaultEmail: defaultEmail,
      confirmationFunc: openSendDialog,
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }
  // *** SEND ESTIMATE END  ***

  const handleAdvanceStep = () => {
    const stepData = {
      billing_step: generalData.billing_step,
      direction: "next",
    }
    dispatch(updateDealMemoBillingStep(stepData, shootId))
      .then(res => {
        const newPage = res.data.step_name.replace(/\s+/g, "-").toLowerCase()
        props.history.push(`/shoots/${shootId}/billing/${newPage}`)
      })
      .catch(err => {
        console.log(err)
      })
  }

  // *** ACCEPT ESTIMATE   ***

  const acceptEstimate = (acceptData, shootId, action) => {
    setActionLoading(true)
    dispatch(updateDealMemoClientStatus(acceptData, shootId, action))
      .then(() => {
        dispatch(openSnackBar({ message: " Estimate Accepted" }))
        setActionLoading(false)
      })
      .catch(err => {
        console.log(err)
        setActionLoading(false)
        dispatch(openSnackBar({ message: "Error accepting estimate" }))
      })
  }

  const confirmAcceptDialog = e => {
    //using button text as key to type - resend or send
    const acceptData = {
      action_type: "accepted",
      client_estimate_signature: `${authenticatedUser.first_name} ${
        authenticatedUser.last_name
      } (Admin)`,
      type: "estimate",
    }
    let confirmationData = {
      confirmationFunc: acceptEstimate,
      funcArgs: [acceptData, shootId, "accept"],
    }

    if (!allSaved) {
      billingContext.setUnsavedErrorBorder(true)
      confirmationData = {
        ...confirmationData,
        action: !allSaved && "accept this estimate  without saving",
      }
    } else {
      confirmationData = { ...confirmationData, action: "accept this estimate" }
    }

    dispatch(toggleClickConfirmationDialog(true, confirmationData))
  }

  // *** ACCEPT ESTIMATE END   ***

  const actionButton = useMemo(
    () => {
      let buttonData = {}
      if (!estimateAccepted) {
        buttonData = {
          func: confirmAcceptDialog,
          buttonText: "Accept Estimate",
        }
      }
      return buttonData
    },
    [estimateAccepted]
  )

  return (
    <Box display="flex" flexDirection="column">
      <Card className={classes.card}>
        <CardContent>
          {!estimateSent &&
            !estimateAccepted && (
              <EstimateDeposit
                loading={switchLoading}
                depositRequired={depositRequired}
                toggleDepositRequired={handleDepositRequired}
                switchDisabled={invoiceSent}
              />
            )}
          {(estimateSent || estimateAccepted) && (
            <EstimateStatusCard
              depositRequired={depositRequired}
              amounts={amounts}
            />
          )}
        </CardContent>
      </Card>
      <Box display="flex" justifyContent="center">
        <Box width="80%" mt={3} mb={3}>
          <GreenButton
            variant="contained"
            onClick={allSaved ? openSendDialog : confirmSendDialog}
            fullWidth
            disabled={sendLoading}
          >
            {sendLoading ? (
              <CircularProgress
                size={25}
                style={{ color: "#fff", marginTop: "2px", marginBottom: "2px" }}
              />
            ) : !estimateSent ? (
              "Send Estimate to Client"
            ) : (
              "Resend Estimate"
            )}
          </GreenButton>

          {!isEmpty(actionButton) && (
            <Box mt={3} mb={3}>
              <LoadingButton
                variant="contained"
                color="primary"
                onClick={actionButton.func}
                fullWidth
                disabled={actionLoading}
              >
                {actionLoading ? (
                  <CircularProgress
                    size={25}
                    style={{
                      color: "#fff",
                      marginTop: "2px",
                      marginBottom: "2px",
                    }}
                  />
                ) : (
                  actionButton.buttonText
                )}
              </LoadingButton>
            </Box>
          )}
          {generalData.billing_step === 1 && (
            <Button
              fullWidth
              style={{
                marginTop: 20,
                color: theme.palette.error.main,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
              disabled={!estimateSent && !estimateAccepted}
              disableRipple
              onClick={handleAdvanceStep}
            >
              Continue to Bill Approval {">"}
            </Button>
          )}
          <Box style={{ marginTop: "50px" }}>
            {generalData.billing_step_name === "Estimate" &&
            window.location.pathname.includes("/estimate") ? (
              <NextStep
                style={{ marginTop: "50px" }}
                message={nextStepMessage}
                shootDate={startDate}
                daysAway={daysAway}
              />
            ) : null}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

EstimateRightContent.propTypes = {
  children: PropTypes.node,
}

export default EstimateRightContent
